module.exports = "/_next/static/media/f8356ebf1b50ce81d489f8f9308c4b98.svg";